export default __webpack_public_path__ + "static/media/dog-walking.3bded8f8.svg";